import {EntityType} from "../@core/entityType";
import {Operation} from "reactcoregk";

export const entityType = EntityType.Technique;
export const entityOperations = [
  Operation.getAll,
  Operation.create,
  Operation.delete,
];
